export default {
	"f348671efa5ce1d8fa52d9190ecf71db": "親愛的用户您好:",
	"ec1a0cd4ddebcceb233d4bde4fa59048": "因春節放假，各區域快遞陸續停運，2025年1月28日-2025年1月31日（共計4天），叫叫將暫停年度系統包首月訂單（首次激活產生的訂單）與成長豆兑換訂單的實物配送，2025年2月1日恢復正常發貨運輸，給您帶來不便敬請諒解，祝您春節愉快！",
	"b003a908fd945588f60f1ce22ad23b24": "叫叫"
}
